import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { Sketch } from '@ckpack/vue-color';
import { VueGpickr, LinearGradient } from 'vue-gpickr';
import { convertJsonToLinearGradient, convertLinearGradientToJson } from '@/utils/utils';
let _ = require('lodash');
export default {
  props: ['value'],
  components: {
    VueGpickr,
    'sketch-picker': Sketch
  },
  data() {
    return {
      fillbackground: 'rgba(51,51,51,1)',
      switchtab2: 0,
      gradient: new LinearGradient({
        angle: 91,
        stops: [['#0359b5', 0], ['#f6ce01', 1]]
      }),
      colors: 'rgba(51,51,51,1)'
    };
  },
  computed: {},
  watch: {
    // gradient (val) {
    //   console.log(`gradient`, val)
    // }
    value(val) {
      console.log(`watch`, val);
      this.formatColor(val);
    }
  },
  mounted() {
    this.$nextTick(() => {
      console.log(`this.value`, this.value);
      this.formatColor(this.value);
    });
  },
  methods: {
    formatColor(val) {
      let color = _.cloneDeep(val);
      if (typeof color === 'object') {
        this.fillbackground = convertJsonToLinearGradient(color);
        this.switchtab2 = 1;
        this.gradient = new LinearGradient({
          angle: color._angle,
          stops: color._stops
        });
      } else {
        this.fillbackground = color;
        this.switchtab2 = 0;
        let formatStr = color.match(/\((.+?)\)/)[1];
        let format = formatStr.split(',');
        this.colors = {
          rgba: {
            r: format[0],
            g: format[1],
            b: format[2],
            a: format[3]
          }
        };
      }
    },
    handleClick() {},
    quithandle() {
      this.$refs.dropdown.handleClose();
    },
    okHandle() {
      let color;
      if (this.switchtab2 === 0) {
        let rgbaval = [];
        Object.keys(this.colors.rgba).forEach(child => {
          rgbaval.push(this.colors.rgba[child]);
        });
        color = _.cloneDeep(`rgba(${rgbaval.join(',')})`);
        this.fillbackground = color;
        this.$emit('color', color);
      } else {
        color = _.cloneDeep(this.gradient);
        this.fillbackground = convertJsonToLinearGradient(color);
        console.log(`this.fillbackground`, this.fillbackground);
        let obj = {};
        Object.keys(color).forEach(key => {
          obj[key] = color[key];
        });
        this.$emit('color', obj);
      }
      this.$refs.dropdown.handleClose();
    },
    refreshGradient() {
      this.gradient = new LinearGradient({
        angle: 91,
        stops: [['#0359b5', 0], ['#f6ce01', 1]]
      });
    }
  }
};